const TEXT = 'text'
const PHONE = 'tel'
const NUMBER = 'number'
const EMAIL = 'email'
const URL = 'url'
const PASSWORD = 'password'
const SELECT = 'select'

// eslint-disable-next-line max-len
const URL_REGEXP = new RegExp(
  /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i,
)
// eslint-disable-next-line max-len
const EMAIL_REGEXP = new RegExp(
  /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/,
)
const NUMBER_REGEXP = new RegExp(/^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/)

function isUndefined(value) {
  return value === undefined || value === null
}

function isDefined(value) {
  return typeof value !== 'undefined'
}

function isNumber(value) {
  return typeof value === 'number'
}

function isString(value) {
  return typeof value === 'string'
}

function toInt(str) {
  return parseInt(str, 10)
}

const isNumberNaN = Number.isNaN

function isEmpty(value) {
  // eslint-disable-next-line no-self-compare
  return isUndefined(value) || value === '' || value === null || value !== value
}

function parseNumber(val) {
  let value = val
  if (isDefined(value) && !isNumber(value)) {
    value = parseFloat(value)
  }
  return !isNumberNaN(value) ? value : undefined
}

function baseInput() {
  return {
    required(value) {
      return isEmpty(value)
    },
    pattern(regexp, value) {
      return isEmpty(value) || isUndefined(regexp) || regexp.test(value) === false
    },
  }
}

function textInput() {
  return {
    ...baseInput(),
    minLength(minVal = 0, value) {
      return isEmpty(value) || value.length < minVal
    },
    maxLength(maxVal = 0, value) {
      return maxVal < 0 || isEmpty(value) || value.length > maxVal
    },
  }
}

function phoneInput() {
  return {
    ...baseInput(),
    required(value) {
      if (isEmpty(value)) {
        return true
      }
      // extrai apenas os numeros, retorna em grupos, junta numa unica string
      const result = value.match(/\d+/g) ? value.match(/\d+/g).join('') : ''
      // invalido se a string do telefone tiver menos que 10 digitos considerando o ddd
      return result.length < 10
    },
  }
}

function passwordInput() {
  return {
    ...baseInput(),
    minLength(minVal = 0, value) {
      return isEmpty(value) || value.length < minVal
    },
    maxLength(maxVal = 0, value) {
      return maxVal < 0 || isEmpty(value) || value.length > maxVal
    },
  }
}

function numberInput() {
  return {
    ...baseInput(),
    required(value) {
      return isEmpty(value) || NUMBER_REGEXP.test(value) === false
    },
    min(minVal, value) {
      return isEmpty(value) || NUMBER_REGEXP.test(value) === false || isUndefined(minVal) || value >= minVal
    },
    max(maxVal, value) {
      return isEmpty(value) || NUMBER_REGEXP.test(value) === false || isUndefined(maxVal) || value <= maxVal
    },
  }
}

function urlInput() {
  return {
    ...baseInput(),
    required(value) {
      return isEmpty(value) || URL_REGEXP.test(value) === false
    },
  }
}

function emailInput() {
  return {
    ...baseInput(),
    required(value) {
      return isEmpty(value) || EMAIL_REGEXP.test(value) === false
    },
  }
}

function selectInput() {
  return {
    ...baseInput(),
  }
}

export function isValidEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export default function(type) {
  let runners
  const asyncValidators = {}
  const syncValidators = {
    required: undefined,
    min: undefined,
    max: undefined,
    minLength: undefined,
    maxLength: undefined,
    pattern: undefined,
  }

  if (type === TEXT) {
    runners = textInput()
  } else if (type === PASSWORD) {
    runners = passwordInput()
  } else if (type === NUMBER) {
    runners = numberInput()
  } else if (type === EMAIL) {
    runners = emailInput()
  } else if (type === URL) {
    runners = urlInput()
  } else if (type === SELECT) {
    runners = selectInput()
  } else if (type === PHONE) {
    runners = phoneInput()
  }

  const validators = {
    set required(value) {
      if (isUndefined(value)) {
        syncValidators.required = value
        return
      }
      syncValidators.required = value
    },
    set min(value) {
      if (isUndefined(value)) {
        syncValidators.min = value
        return
      }
      syncValidators.min = parseNumber(value)
    },
    set max(value) {
      if (isUndefined(value)) {
        syncValidators.max = value
        return
      }
      syncValidators.max = parseNumber(value)
    },
    set minLength(value) {
      if (isUndefined(value)) {
        syncValidators.minLength = value
        return
      }
      syncValidators.minLength = toInt(value) || 0
    },
    set maxLength(value) {
      if (isUndefined(value)) {
        syncValidators.maxLength = value
        return
      }
      const intVal = toInt(value)
      syncValidators.maxLength = isNumberNaN(intVal) ? -1 : intVal
    },
    set pattern(value) {
      if (isUndefined(value)) {
        syncValidators.pattern = value
        return
      }
      let regex = value
      if (isString(regex) && regex.length > 0) {
        regex = new RegExp(`^${regex}$`)
      }

      if (regex && !regex.test) {
        throw new Error('Expected to be a RegExp.')
      }

      syncValidators.pattern = regex || undefined
    },
    get async() {
      return asyncValidators
    },
    run(value) {
      const error = {}
      let allValid = true
      let callback

      function setValidity(name, isInvalid) {
        error[name] = isInvalid
        allValid = allValid && !isInvalid
      }

      function validationDone() {
        return { error, valid: allValid, invalid: allValid === false }
      }

      function validationWaitingDone(cb) {
        callback = cb
      }

      function validationAsyncDone() {
        if (callback) {
          callback(validationDone())
        }
      }

      function processSyncValidators() {
        if (isDefined(syncValidators.required)) {
          setValidity('required', runners.required(value))
        }
        if (isDefined(syncValidators.min)) {
          setValidity('min', runners.min(syncValidators.min, value))
        }
        if (isDefined(syncValidators.max)) {
          setValidity('max', runners.max(syncValidators.max, value))
        }
        if (isDefined(syncValidators.minLength)) {
          setValidity('minLength', runners.minLength(syncValidators.minLength, value))
        }
        if (isDefined(syncValidators.maxLength)) {
          setValidity('maxLength', runners.maxLength(syncValidators.maxLength, value))
        }
        if (isDefined(syncValidators.pattern)) {
          setValidity('pattern', runners.pattern(syncValidators.pattern, value))
        }

        return Object.keys(asyncValidators).length > 0
      }

      function processAsyncValidators() {
        const validatorPromises = []
        const validatorsAsync = Object.keys(asyncValidators).map((name) => ({
          name,
          validator: asyncValidators[name],
        }))
        validatorsAsync.forEach(({ name, validator }) => {
          const promise = validator(value)
          validatorPromises.push(
            promise.then(
              () => {
                setValidity(name, false)
              },
              () => {
                setValidity(name, true)
              },
            ),
          )
        })

        Promise.all(validatorPromises).then(validationAsyncDone, validationAsyncDone)
      }

      if (!processSyncValidators() || !allValid) {
        return validationDone()
      }

      processAsyncValidators()
      return { ...validationDone(), pending: true, callback: validationWaitingDone }
    },
  }

  return validators
}

export { EMAIL_REGEXP }



// WEBPACK FOOTER //
// ./src/lib/validators.js